import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Home from './screens/Home';
import GameWrapper from './screens/GameWrapper';
import RandomGame from './screens/RandomGame';
import Progress from './screens/Progress';
import Settings from './screens/Settings';
import VerseSearchModal, { VerseSearchFAB } from './components/VerseSearch';
import './App.css';

function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  const handleKeyDown = useCallback((e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      e.preventDefault();
      setSearchOpen((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game/:id" element={<GameWrapper />} />
          <Route path="/random" element={<RandomGame />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
        <VerseSearchFAB onClick={() => setSearchOpen(true)} />
        <VerseSearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
      </Router>
    </LanguageProvider>
  );
}

export default App;
